module.exports = __webpack_public_path__ + "img/estate.0c5ee1ac.svg";